import * as S from "./ScatterChart.style";
import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
interface ScatterChartProps {
  chartData: any;
}

export const ScatterChart = ({ chartData }: ScatterChartProps) => {
  const options = useMemo(
    () => ({
      dataset: [
        {
          // 전체 데이터
          source: chartData?.result || [],
        },
        {
          // normal 데이터만 포함
          transform: {
            type: "filter",
            config: {
              dimension: 3,
              value: 0,
            },
          },
        },
        {
          // warning 데이터만 포함
          transform: {
            type: "filter",
            config: {
              dimension: 3,
              value: 1,
            },
          },
        },
        {
          // critical 데이터만 포함
          transform: {
            type: "filter",
            config: {
              dimension: 3,
              value: 2,
            },
          },
        },
      ],
      grid: {
        containLabel: true,
        left: 10,
        top: 25,
        right: 10,
        bottom: 0,
      },
      xAxis: {
        splitLine: {
          lineStyle: {
            type: "dashed",
          },
        },
        splitNumber: 20,
        min: 0,
        max: 100,
      },
      yAxis: {
        type: "value",
        min: chartData.result[0][2]?.min,
        max: chartData.result[0][2]?.max,
        splitLine: {
          lineStyle: {
            type: "dashed",
          },
        },
        name: `단위: ${chartData?.YUnit}`,
        nameLocation: "end",
        nameRotate: 0,
        nameGap: 10,
        position: "left",
        nameTextStyle: {
          padding: [10, 0, 0, 40],
        },
      },
      series: [
        {
          name: "normal",
          type: "scatter",
          encode: { x: 0, y: 1 },
          datasetIndex: 1, // 첫 번째 필터된 dataset 사용
          itemStyle: { color: "#5470C6" }, // normal 색상
          z: 1, // 우선순위 설정
        },
        {
          name: "warning",
          type: "scatter",
          encode: { x: 0, y: 1 },
          datasetIndex: 2, // 두 번째 필터된 dataset 사용
          itemStyle: { color: "orange", opacity: 0.5 }, // warning 색상
          z: 2, // warning을 더 위에 설정
        },
        {
          name: "critical",
          type: "scatter",
          encode: { x: 0, y: 1 },
          datasetIndex: 3, // 세 번째 필터된 dataset 사용
          itemStyle: { color: "red", opacity: 0.3 }, // critical 색상
          z: 3, // critical을 더 위에 설정
        },
      ],
    }),
    [chartData?.result]
  );

  return (
    <S.ScatterChartBox>
      <ReactECharts
        echarts={echarts}
        option={options}
        opts={{ renderer: "svg" }}
        style={{ width: "100%", height: "100%" }}
      />
    </S.ScatterChartBox>
  );
};
